import './ListResult.scss'

import React from 'react'
import { Link } from 'react-router-dom'
import pluralize from 'pluralize'

import { urlListView } from '../../../../../urls'
import ListActionsDropdown from '../../../ListActionsDropdown/ListActionsDropdown'

const ListResult = ({ list }) => {
  return (
    <div className="list-result">
      <div className="list-result__container">
        <Link to={urlListView(list.getID())} className="list-result__list-name">
          {list.getName()}
        </Link>
        {list.updatedDate && (
          <div className="list-result__updated-date">Last updated on {list.getUpdatedDateFormatted()}</div>
        )}
        <div className="list-result__results-count">{pluralize('Item', list.getTotalItemsCount(), true)}</div>
        {list.isPersonalList() && (
          <div className="list-result__actions-dropdown">
            <ListActionsDropdown list={list} />
          </div>
        )}
      </div>
    </div>
  )
}

export default ListResult
